import React from "react";
import DonutChart from "../../../components/donut/donut";
import Table from "../../../components/coreUiTable/Table";
import { addGaps, limitedColHeaders } from "../utils/dataForTables";
import { cuFormat } from "../../../components/coreUiTable/Format";

export const PiesAndTable = ({
  chartData: { tableData: { data = [], columns = [], links = [] } = {}, pieValues = [] } = {},
  chartData = {},
  pieTitle,
  tableTitle
}) => {
  if (data.length > 0) {
    addGaps(data, links);
  }

  return Object.keys(chartData).length ? (
    <div className="dailyPulse__section dailyPulse__section__row">
      <div className="content">
        <p className="title">{pieTitle}</p>
        {pieValues.map((pie) => {
          const { name, share, value } = pie;
          return (
            <div className="content__el" key={name}>
              <DonutChart type={name} value={share * 100} dollarValue={value} hidePercentChanged />
            </div>
          );
        })}
      </div>

      <div className="content">
        <p className="title">{tableTitle}</p>

        <div className="content__el">
          <Table
            table={{ data, colHeaders: limitedColHeaders }}
            pagination={false}
            tableFilter={false}
            tableWrapperId="dailyPulseTable"
            scopedSlots={cuFormat({ headers: limitedColHeaders, columns, links })}
          />
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};
